module.exports = __webpack_public_path__ + "files/bac61997af03ef4747cd73b3757749ca.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Caligraphic-Bold.woff
// module id = 1168
// module chunks = 76